import React, { useCallback } from 'react';
import { Avatar, Card } from 'antd';
import { DEFAULT_AVATAR } from '@gtintel/platform-constants';
import OptionsPopover from '../OptionsPopover';
import * as S from './styles';
const {
  Meta
} = Card;
const MemberCard = ({
  description,
  member,
  canRemove,
  onRemove
}) => {
  const handleRemove = useCallback(() => {
    onRemove && onRemove(member);
  }, [member, onRemove]);
  return <S.Container data-testid="member-card">
      <Meta avatar={<Avatar src={member?.avatar ?? DEFAULT_AVATAR} size={38} />} title={`${member?.first_name} ${member?.last_name}`} description={description} />
      {canRemove && onRemove && <OptionsPopover>
          <S.OptionText onClick={handleRemove}>Remove Member</S.OptionText>
        </OptionsPopover>}
    </S.Container>;
};
export default MemberCard;